import { useSelector, useDispatch } from "react-redux";
import {
  changeRole,
  forgot,
  login,
  logout,
  reset,
  resetAuth,
  setAdminAccess,
  signup,
} from "../store/auth";
function useAuthStore() {
  const dispatch = useDispatch();

  const token = useSelector((state) => state.auth?.token);

  const isLoggedIn = useSelector((state) => state.auth.isAuth);
  const admin = useSelector((state) => state.auth.admin);
  const status = useSelector((state) => state.auth.status);
  const error = useSelector((state) => state.auth.error);
  const loading = useSelector((state) => state.auth.ui.loading);
  const role = useSelector((state) => state.auth.role);
  const isAuth = useSelector((state) => state.auth.isAuth);
  const userId = useSelector((state) => state.auth.userId);
  const loginUsername = useSelector((state) => state.auth.loginUsername);
  const institutionId = useSelector((state) => state.auth.institutionId);
  const loginAction = (params) => dispatch(login(params));
  const signupAction = (params) => dispatch(signup(params));
  const logoutAction = () => dispatch(logout());
  const resetAction = (params) => dispatch(reset(params));
  const forgotAction = (params) => dispatch(forgot(params));
  const resetAuthAction = () => dispatch(resetAuth());
  const setAdminAccessAction = (params) => dispatch(setAdminAccess(params));
  const changeRoleAction = (params) => dispatch(changeRole(params));

  return {
    // states
    token,
    role,
    isLoggedIn,
    status,
    error,
    loading,
    isAuth,
    userId,
    loginUsername,
    institutionId,
    admin,

    
    // actions
    loginAction,
    signupAction,
    logoutAction,
    resetAction,
    forgotAction,
    resetAuthAction,
    setAdminAccessAction,
    changeRoleAction,
  };
}

export default useAuthStore;
